(function () {
  'use strict';

  if (window.ModobloomReviewRating) {
    window.ModobloomReviewRating.scan();
    return;
  }

  var records = new Map();
  var sourcePriority = { badge: 1, summary: 2, metafield: 3 };
  var scanQueued = false;

  function normalizeProductId(value) {
    return String(value || '').trim();
  }

  function getWidgetButton(widget, createIfMissing) {
    var buttons = Array.from(widget.querySelectorAll('.kl_reviews__star_rating_widget'));
    var button = buttons.find(function (candidate) {
      return candidate.hasAttribute('aria-label');
    }) || buttons[0];

    buttons.forEach(function (candidate) {
      if (candidate !== button) candidate.remove();
    });

    if (!button && createIfMissing) {
      button = document.createElement('span');
      button.className = 'kl_reviews__star_rating_widget';

      var badge = document.createElement('span');
      badge.className = 'kl_reviews__stars_badge';
      button.appendChild(badge);
      widget.appendChild(button);
    }

    return button;
  }

  function parseBadge(widget) {
    var button = getWidgetButton(widget, false);
    if (!button) return null;

    var label = String(button.getAttribute('aria-label') || '');
    var match = label.match(/([0-9]+(?:[.,][0-9]+)?)\s+stars?,\s*([0-9]+)\s+(?:ratings?|reviews?)/i);
    if (!match) return null;

    return {
      rating: Number.parseFloat(match[1].replace(',', '.')),
      count: Number.parseInt(match[2], 10),
      button: button
    };
  }

  function parseMetafieldData(widget) {
    var rating = Number.parseFloat(String(widget.dataset.reviewRating || '').replace(',', '.'));
    var count = Number.parseInt(String(widget.dataset.reviewCount || '').replace(/,/g, ''), 10);
    if (!Number.isFinite(rating) || !Number.isFinite(count)) return null;

    return { rating: rating, count: count };
  }

  function parseSummary(summary) {
    var average = summary.querySelector('.kl_reviews__summary__average_value');
    var countNode = summary.querySelector('.kl_reviews__summary__stars__count');
    var countMatch = String(countNode ? countNode.textContent : '').match(/([0-9][0-9,]*)/);
    if (!average || !countMatch) return null;

    return {
      rating: Number.parseFloat(String(average.textContent || '').trim().replace(',', '.')),
      count: Number.parseInt(countMatch[1].replace(/,/g, ''), 10)
    };
  }

  function isValid(record) {
    return Number.isFinite(record && record.rating)
      && record.rating >= 0
      && Number.isFinite(record.count)
      && record.count >= 0;
  }

  function formatRating(value) {
    return value.toFixed(2).replace(/\.?0+$/, '');
  }

  function clampRating(value) {
    return Math.max(0, Math.min(5, Number(value) || 0));
  }

  function renderStarsBadge(badge, rating) {
    if (!badge) return;

    var stars = badge.querySelector('.modobloom-review-stars');
    if (!stars) {
      stars = document.createElement('span');
      stars.className = 'modobloom-review-stars';
      stars.setAttribute('aria-hidden', 'true');

      for (var index = 0; index < 5; index += 1) {
        var star = document.createElement('span');
        star.className = 'modobloom-review-star';
        var fill = document.createElement('span');
        fill.className = 'modobloom-review-star__fill';
        star.appendChild(fill);
        stars.appendChild(star);
      }

      badge.appendChild(stars);
      badge.classList.add('is-modobloom-starred');
    }

    var normalizedRating = clampRating(rating);
    stars.querySelectorAll('.modobloom-review-star').forEach(function (star, index) {
      var percent = Math.round(Math.max(0, Math.min(100, (normalizedRating - index) * 100)) * 100) / 100;
      var nextFill = percent + '%';
      if (star.style.getPropertyValue('--modobloom-review-star-fill') !== nextFill) {
        star.style.setProperty('--modobloom-review-star-fill', nextFill);
      }
    });
  }

  function parseNativeBadgeRating(badge) {
    var stars = Array.from(badge ? badge.querySelectorAll('svg') : []);
    if (!stars.length) return null;

    var rating = 0;
    var found = false;
    stars.slice(0, 5).forEach(function (star) {
      var fillStop = star.querySelector("stop[id^='fill-stop-1']");
      var offset = fillStop ? Number.parseFloat(fillStop.getAttribute('offset')) : NaN;
      if (Number.isFinite(offset)) {
        rating += Math.max(0, Math.min(100, offset)) / 100;
        found = true;
      }
    });

    return found ? rating : null;
  }

  function parseJudgeMeRating(badge) {
    var dataRating = badge && (
      badge.getAttribute('data-score')
      || badge.getAttribute('data-rating')
      || badge.getAttribute('data-review-rating')
    );
    var parsedDataRating = Number.parseFloat(String(dataRating || '').replace(',', '.'));
    if (Number.isFinite(parsedDataRating)) return parsedDataRating;

    var label = String(badge ? badge.getAttribute('aria-label') || badge.textContent || '' : '');
    var labelMatch = label.match(/([0-5](?:[.,][0-9]+)?)\s*(?:out of\s*5|stars?)/i);
    return labelMatch ? Number.parseFloat(labelMatch[1].replace(',', '.')) : null;
  }

  function ensureWidgetButton(widget) {
    return getWidgetButton(widget, true);
  }

  function renderWidget(widget, record) {
    if (!isValid(record)) return;
    var button = ensureWidgetButton(widget);

    var nativeLabel = button.querySelector('.kl_reviews__star_rating_widget__label');
    if (nativeLabel) nativeLabel.hidden = true;

    var label = button.querySelector('.modobloom-review-rating__plugin-label');
    if (!label) {
      label = document.createElement('span');
      label.className = 'modobloom-review-rating__plugin-label';
      button.appendChild(label);
    }

    var nextLabel = formatRating(record.rating) + ' | ' + record.count + ' ' + (record.count === 1 ? 'Review' : 'Reviews');
    if (label.textContent !== nextLabel) label.textContent = nextLabel;

    var ariaLabel = formatRating(record.rating) + ' stars, ' + record.count + ' ' + (record.count === 1 ? 'rating' : 'ratings');
    if (button.getAttribute('aria-label') !== ariaLabel) button.setAttribute('aria-label', ariaLabel);
    renderStarsBadge(button.querySelector('.kl_reviews__stars_badge'), record.rating);
  }

  function renderProduct(productId) {
    if (!productId) return;
    var record = records.get(productId);
    if (!record) return;

    document.querySelectorAll('[data-modobloom-rating-widget]').forEach(function (widget) {
      if (normalizeProductId(widget.dataset.id) === productId) renderWidget(widget, record);
    });
  }

  function publish(productId, rating, count, source) {
    productId = normalizeProductId(productId);
    var next = { rating: rating, count: count, source: source };
    if (!productId || !isValid(next)) return;

    var current = records.get(productId);
    if (current && sourcePriority[current.source] > sourcePriority[source]) return;
    records.set(productId, next);
    renderProduct(productId);
  }

  function scan() {
    document.querySelectorAll('[data-modobloom-rating-widget]').forEach(function (widget) {
      var metafieldData = parseMetafieldData(widget);
      if (metafieldData) {
        publish(widget.dataset.id, metafieldData.rating, metafieldData.count, 'metafield');
      }

      var parsed = parseBadge(widget);
      if (parsed) publish(widget.dataset.id, parsed.rating, parsed.count, 'badge');
    });

    document.querySelectorAll('[data-modobloom-review-summary][data-product-id]').forEach(function (scope) {
      var summary = scope.querySelector('.kl_reviews__summary__average_and_stars') || scope;
      var parsed = parseSummary(summary);
      if (parsed) {
        publish(scope.dataset.productId, parsed.rating, parsed.count, 'summary');
        renderStarsBadge(summary.querySelector('.kl_reviews__stars_badge'), parsed.rating);
      }
    });

    document.querySelectorAll('.r1-klaviyo-reviews .kl_reviews__stars_badge').forEach(function (badge) {
      if (badge.closest('.kl_reviews__star_rating_widget')) return;
      if (badge.closest('.kl_reviews__summary__average_and_stars')) return;

      var rating = parseJudgeMeRating(badge);
      if (rating === null) rating = parseNativeBadgeRating(badge);
      if (rating !== null) renderStarsBadge(badge, rating);
    });
  }

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
  }

  var reviewScrollStoragePrefix = 'modobloom:review-scroll:';

  function getReviewScrollStorageKey() {
    return reviewScrollStoragePrefix + window.location.pathname + window.location.search;
  }

  function markReviewScrollForNextLoad() {
    try {
      window.sessionStorage.setItem(getReviewScrollStorageKey(), '1');
    } catch (error) {
      // Storage may be unavailable; preventing the URL fragment still works.
    }
  }

  function consumeReviewScrollMarker() {
    try {
      var key = getReviewScrollStorageKey();
      if (window.sessionStorage.getItem(key) !== '1') return false;
      window.sessionStorage.removeItem(key);
      return true;
    } catch (error) {
      return false;
    }
  }

  function resetReviewScrollAfterReload() {
    if (!consumeReviewScrollMarker()) {
      if ('scrollRestoration' in window.history && window.history.scrollRestoration === 'manual') {
        window.history.scrollRestoration = 'auto';
      }
      return;
    }

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    var resetScroll = function () {
      window.scrollTo(0, 0);
    };

    resetScroll();
    document.addEventListener('DOMContentLoaded', resetScroll, { once: true });
    window.addEventListener('load', resetScroll, { once: true });
    window.addEventListener('pageshow', resetScroll, { once: true });
  }

  function handleReviewAnchorClick(event) {
    if (
      event.defaultPrevented
      || event.button !== 0
      || event.metaKey
      || event.ctrlKey
      || event.shiftKey
      || event.altKey
      || !(event.target instanceof Element)
    ) return;

    var link = event.target.closest('.modobloom-review-rating[href^="#"]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || href.length < 2) return;

    var targetId = href.slice(1);
    try {
      targetId = decodeURIComponent(targetId);
    } catch (error) {
      // Keep the literal ID when the fragment contains invalid encoding.
    }

    var target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    markReviewScrollForNextLoad();
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  resetReviewScrollAfterReload();
  window.ModobloomReviewRating = { scan: scan, publish: publish };
  document.addEventListener('click', handleReviewAnchorClick);
  new MutationObserver(queueScan).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['aria-label']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
})();
